import { Outlet } from "react-router-dom";

export function PortalLayout() {
  return (
    <div className="bg-muted min-h-[calc(100vh-4rem)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </div>
    </div>
  );
}
